import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './AdminPages.css';

const Enquiries = () => {
  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchEnquiries(); }, []);

  const fetchEnquiries = async () => {
    try {
      const res = await axios.get('/api/admin/enquiries');
      setEnquiries(res.data);
    } catch (err) {
      console.error('Error fetching enquiries:', err);
    } finally {
      setLoading(false);
    }
  };

  const updateStatus = async (id, status) => {
    try {
      await axios.put(`/api/admin/enquiries/${id}/status`, { status });
      fetchEnquiries();
    } catch (err) {
      alert('Error updating enquiry');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this enquiry?')) return;
    try {
      await axios.delete(`/api/admin/enquiries/${id}`);
      fetchEnquiries();
    } catch (err) {
      alert('Error deleting enquiry');
    }
  };

  if (loading) return <div className="admin-loading">Loading...</div>;

  return (
    <div className="admin-page admin-page-wide">
      <div className="admin-page-header">
        <div>
          <h2 className="admin-page-title">Enquiries</h2>
          <p className="admin-page-desc">Customer enquiries and contact messages. ({enquiries.length} total)</p>
        </div>
      </div>

      <div className="admin-page-card admin-table-card">
        <div className="admin-notifications-table">
          <table>
            <thead>
              <tr><th>Name</th><th>Email</th><th>Phone</th><th>Message</th><th>Status</th><th>Date</th><th>Actions</th></tr>
            </thead>
            <tbody>
              {enquiries.length === 0 ? (
                <tr><td colSpan="7" className="admin-no-data">No enquiries yet.</td></tr>
              ) : enquiries.map(enq => (
                <tr key={enq._id}>
                  <td><strong>{enq.name}</strong></td>
                  <td>{enq.email}</td>
                  <td>{enq.phone || '--'}</td>
                  <td style={{ maxWidth: '250px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{enq.message}</td>
                  <td>
                    <span className={`admin-status-badge admin-status-${enq.status || 'pending'}`}>
                      {enq.status || 'pending'}
                    </span>
                  </td>
                  <td>{new Date(enq.createdAt).toLocaleDateString()}</td>
                  <td>
                    <div className="admin-action-buttons">
                      {enq.status !== 'closed' && (
                        <button className="admin-btn-icon admin-btn-edit" onClick={() => updateStatus(enq._id, 'closed')}>Close</button>
                      )}
                      <button className="admin-btn-icon admin-btn-delete" onClick={() => handleDelete(enq._id)}>Delete</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Enquiries;
